import { render, staticRenderFns } from "./UserLoginWrapper.vue?vue&type=template&id=4008fe0b"
import script from "./UserLoginWrapper.vue?vue&type=script&lang=js"
export * from "./UserLoginWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports